import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { connectModal as reduxModal } from 'redux-modal';
import { submit } from 'redux-form';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/common/modal';

import SubmitButton from 'ui/common/form/submit-button';

import { addEducationEntry } from 'store/features/education/actions';
import createForm from 'ui/education/form';

const { request: addEducationEntryRequest } = addEducationEntry;

const messages = defineMessages({
  title: {
    id: 'new-education-entry-dialog.title',
    defaultMessage: 'Add Education',
  },
  save: {
    id: 'new-education-entry-dialog.save',
    defaultMessage: 'Save',
  },
  cancel: {
    id: 'new-education-entry-dialog.cancel',
    defaultMessage: 'Cancel',
  },
});

export const MODAL_NAME = 'new-education-entry-modal';
const FORM_NAME = 'new-education-entry-form-modal';

class NewEducationEntry extends Component {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  onSubmit(values) {
    const { currentlyStudying } = values;
    if (currentlyStudying) values.endDate = null;
    this.props.addEducationEntryRequest(values, { form: FORM_NAME, modal: MODAL_NAME });
  }

  getForm() {
    const Form = createForm({
      form: FORM_NAME,
      onSubmit: this.onSubmit,
    });
    return <Form />;
  }

  render() {
    const { show, intl: { formatMessage }, handleHide } = this.props;

    const form = this.getForm();

    return (
      <Modal isOpen={show} size="lg">
        <ModalHeader toggle={handleHide}>{formatMessage(messages.title)}</ModalHeader>
        <ModalBody>{form}</ModalBody>
        <ModalFooter>
          <SubmitButton size="md" formName={FORM_NAME} explicitlyTriggerSubmit>
            {formatMessage(messages.save)}
          </SubmitButton>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  submit,
  addEducationEntryRequest,
};

export default connect(null, mapDispatchToProps)(
  reduxModal({
    name: MODAL_NAME,
  })(injectIntl(NewEducationEntry))
);
